<div class="global-conntect-app-dialog">
  <sc-flex fitHeight vertical>
    <sc-flex-fitting-content vertical>
      <img src="/assets/default/icons/app-store/{{store}}-badge-{{translationService.language}}.{{extension}}"
        class="app-badge {{store}}-badge" alt="" />
        <div class="qr-code-box">
          @if (qrCodeUrl) {
            <qrcode [qrdata]="qrCodeUrl" [scale]="8"></qrcode>
          }
        </div>
      </sc-flex-fitting-content>
      <sc-actionbar>
        <sc-content-spacer grow></sc-content-spacer>
        <sc-close-button primary matDialogClose cdkFocusInitial></sc-close-button>
      </sc-actionbar>
    </sc-flex>
  </div>
